export const formatRewardPoints = (rewardPoints?: number) => rewardPoints?.toLocaleString('en-NZ') || '0';
